import React, { useEffect } from "react";
import { pushRoute } from "src/utils/constants/routes";
import useTranslation from "next-translate/useTranslation";
import { hasAuthPermission } from "src/utils/hasAuthPermission";
import { useAuthState } from "src/shared/contexts/AuthContext";
import WithWaitForAuthentication from "src/shared/hocs/WithWaitForAuthentication";
import { Flex, Spinner } from "@chakra-ui/react";
import SmileSignUp from "src/modules/smile/pages/Signup";
import { APP_HOME_ROUTE } from "src/modules/smile/shared/consts";

const SmileSignUpPage = () => {
  const { isAuthenticated, profile } = useAuthState();
  const { lang } = useTranslation();

  useEffect(() => {
    if (isAuthenticated && profile) {
      if ("smilePlusStatePlan" in profile && hasAuthPermission(profile?.smilePlusStatePlan)) {
        pushRoute(APP_HOME_ROUTE, lang);
      }
    }
  }, [isAuthenticated, profile]);

  if (profile && !("smilePlusStatePlan" in profile)) {
    return (
      <Flex h="100vh" w="100vw" justify="center" align="center">
        <Spinner size="xl" color="brandBlue.100" thickness="5px" />
      </Flex>
    );
  }

  return <SmileSignUp />;
};

export default WithWaitForAuthentication(SmileSignUpPage);
